import React, { useState } from 'react';

const youtubeVideos = [
  { id: 'ezlGCfIIK1k', title: 'School Life' },
  { id: 'SqotPzgR_Yg', title: 'Annual Day' },
  { id: 'y3BOY8f6IDs', title: 'Science Exhibition' },
];

const YouTubeGalleryModal = () => {
  const [activeVideo, setActiveVideo] = useState(null);

  const openModal = (id) => setActiveVideo(id);
  const closeModal = () => setActiveVideo(null);

  return (
    <section className="youtube-gallery" style={{ padding: '60px 20px', backgroundColor: '#f9f9f9' }}>
      <div style={{ maxWidth: '1100px', margin: '0 auto', textAlign: 'center' }}>
        <h2 style={{ fontSize: '2rem', color: '#125303', marginBottom: '30px' }}>Video Gallery</h2>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
          gap: '25px',
        }}>
          {youtubeVideos.map((video, idx) => (
            <div
              key={idx}
              onClick={() => openModal(video.id)}
              style={{
                cursor: 'pointer',
                position: 'relative',
                borderRadius: '12px',
                overflow: 'hidden',
                boxShadow: '0 6px 12px rgba(0,0,0,0.1)',
              }}
            >
              <img
                src={`https://img.youtube.com/vi/${video.id}/hqdefault.jpg`}
                alt={video.title}
                style={{ width: '100%', height: '200px', objectFit: 'cover' }}
              />
              <div style={{
                position: 'absolute',
                top: '0',
                left: '0',
                width: '100%',
                height: '100%',
                background: 'rgba(0,0,0,0.3)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#fff',
                fontSize: '2rem',
              }}>
                ▶
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Modal */}
      {activeVideo && (
        <div
          onClick={closeModal}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(0,0,0,0.8)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 9999,
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              position: 'relative',
              width: '90%',
              maxWidth: '800px',
              backgroundColor: '#000',
              borderRadius: '8px',
              overflow: 'hidden',
              boxShadow: '0 4px 20px rgba(0,0,0,0.6)',
            }}
          >
            <iframe
              width="100%"
              height="450"
              src={`https://www.youtube.com/embed/${activeVideo}?autoplay=1`}
              title="YouTube video"
              frameBorder="0"
              allow="autoplay; encrypted-media"
              allowFullScreen
            ></iframe>
            <button
              onClick={closeModal}
              style={{
                position: 'absolute',
                top: '10px',
                right: '10px',
                background: '#fff',
                border: 'none',
                borderRadius: '50%',
                width: '32px',
                height: '32px',
                fontSize: '16px',
                fontWeight: 'bold',
                cursor: 'pointer',
              }}
            >
              ✕
            </button>
          </div>
        </div>
      )}
    </section>
  );
};

export default YouTubeGalleryModal;
